module.exports = __webpack_public_path__ + "img/logo-white.71e94953.png";